import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/dealerships/[id]/_components/DealershipPage.tsx");
